var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGraphMotivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.894 60c-1.338 0-2.376-1.328-2.21-2.828 1.232-11.129 9.635-19.74 19.817-19.74 10.183 0 18.585 8.611 19.817 19.74.166 1.5-.872 2.828-2.21 2.828H14.895z",
    fill: "#10B9B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#10B9B2",
    cx: 32.397,
    cy: 27.111,
    rx: 9.341,
    ry: 9.365
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 23.898a5.163 5.163 0 0 1 .638 7.289l-9.101 10.798a5.208 5.208 0 0 1-7.321.64 5.163 5.163 0 0 1-.638-7.288L53.7 24.538a5.208 5.208 0 0 1 7.32-.64zM3.98 23.992a5.163 5.163 0 0 0-.638 7.289l9.101 10.798a5.208 5.208 0 0 0 7.321.64 5.163 5.163 0 0 0 .638-7.288L11.3 24.632a5.208 5.208 0 0 0-7.32-.64z",
    fill: "#93DFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.811 6.96.667.686a1.916 1.916 0 0 1-.048 2.72l-6.189 5.923a1.916 1.916 0 0 1-2.697-.047l-.667-.685a1.916 1.916 0 0 1 .048-2.721l6.19-5.923a1.916 1.916 0 0 1 2.696.047zM14.742 6.96l-.668.686a1.916 1.916 0 0 0 .048 2.72l6.19 5.923c.76.727 1.963.706 2.696-.047l.668-.685a1.916 1.916 0 0 0-.048-2.721l-6.19-5.923a1.916 1.916 0 0 0-2.696.047zM31.799.006l.967-.002a1.916 1.916 0 0 1 1.92 1.92l-.02 8.538a1.916 1.916 0 0 1-1.912 1.911l-.967.002a1.916 1.916 0 0 1-1.92-1.92l.02-8.538A1.916 1.916 0 0 1 31.799.006z",
    fill: "#FFC147"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphMotivation);
export default __webpack_public_path__ + "static/media/icons_graph_motivation.ce0f491f69e132ef7fc74b57798c8b68.svg";
export { ForwardRef as ReactComponent };